import { Component } from '@angular/core';

@Component({
    selector: 'bp2s-top-nav',
    templateUrl: './top-nav.component.html',
    styleUrls: ['./top-nav.component.scss'],
    standalone: false
})
export class TopNavComponent {

  constructor() { }

}
